import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  connect() {
    this.inputTarget.addEventListener("input", () => this.updatePreview())
    this.inputTarget.addEventListener("change", () => this.updatePreview())
    this.updatePreview()
  }

  updatePreview() {
    this.previewTarget.style.backgroundColor = this.inputTarget.value || "transparent"
  }
}
